export const INFRA_TIMEOUT = 504;
